import { Link } from 'react-router-dom';
import { TenantFeedSettings } from '../features/visits/TenantFeedSettings';
import { usePageTitle } from '../hooks/usePageTitle';

export function SettingsCalendarFeedPage() {
  usePageTitle('Calendar subscription');
  return (
    <div className="mx-auto max-w-2xl space-y-4 px-4 py-6 pb-24 sm:pb-8">
      <div>
        <Link to="/settings" className="text-sm text-slate-500 hover:text-pine">← Settings</Link>
        <h1 className="mt-2 font-display text-2xl font-semibold text-ink">Calendar subscription</h1>
      </div>
      <TenantFeedSettings />
    </div>
  );
}
